module.exports = __webpack_public_path__ + "img/1546030276.31003218.jpg";